<template>
	<div class="pa-2">
		<v-row
			align="center"
			class="mb-2"
			dense>
			<!-- filter -->
			<v-col cols="2">
				<v-autocomplete
					v-model="type"
					:items="permissions"
					item-text="name"
					item-value="id"
					label="نوع الأذن"
					outlined
					dense
					hide-details
					@change="searchByType()"
				/>
			</v-col>
			<v-spacer></v-spacer>
			<v-divider
				vertical
				class="mx-1"></v-divider>
			<v-col cols="auto">
				<v-btn @click="exportFile()" :loading="excelLoading" class="mx-1" small color="success">
					<v-icon small class="pe-1"> mdi-export </v-icon>
					تصدير لإكسل
				</v-btn>
				<v-btn
					:disabled="employee.status === employeesTypes.former.value"
					@click="openDialog"
					color="primary"
					small>
					<v-icon
						size="20"
						left>
						$add
					</v-icon>
					{{ $T('add-permission') }}
				</v-btn>
			</v-col>
		</v-row>

		<bee-handy-table
			ref="table"
			:headers="headers"
			:items="items"
			:loading="loading"
			:data-table-props="{ disableSort: true }"
			dense
			zebra
			fixed-header
			:height="$vuetify.breakpoint.height - 230"
			hide-default-footer>
			<template v-slot:item.startDate="{ item }">
				{{
					moment(item.startTime).isValid()
						? moment(item.startTime).format(item.isDaily ? 'L' : 'LT')
						: '-'
				}}
			</template>
			<template v-slot:item.endDate="{ item }">
				{{
					moment(item.startTime).isValid()
						? moment(item.startTime)
								.add(
									item.isDaily ? item.durationInDay : item.durationInMinute,
									item.isDaily ? 'd' : 'm',
								)
								.format(item.isDaily ? 'L' : 'LT')
						: '-'
				}}
			</template>

			<template v-slot:item.actions="{ item }">
				<div class="d-flex">
					<tooltip :text="$T('tooltips.employee')">
						<v-btn
							:to="{
								name: 'personal-info',
								query: { employeeId: item.employeeId },
							}"
							small
							icon>
							<v-icon
								size="20"
								color="preview">
								$viewEmployee
							</v-icon>
						</v-btn>
					</tooltip>
					<tooltip :text="$T('tooltips.edit')">
						<v-btn
							small
							icon
							@click="
								openDialog({
									employee: item.employee,
									item: item,
								})
							">
							<v-icon
								size="20"
								color="edit-color">
								$edit
							</v-icon>
						</v-btn>
					</tooltip>
					<tooltip :text="$T('tooltips.delete')">
						<v-btn
							small
							icon
							@click="
								deleteDialog = true;
								deleteItem = item.id;
							">
							<v-icon
								size="20"
								color="alert">
								$delete
							</v-icon>
						</v-btn>
					</tooltip>
				</div>
			</template>
		</bee-handy-table>

		<!-- add work dialog -->
		<v-dialog
			v-model="showDialog"
			max-width="400px"
			transition="dialog-transition">
			<b-add-vacation
				:vacation-type="1"
				:selected-item="dialogItem"
				:one-employee="employeeId"
				@close="showDialog = false"
				@done="fetch(search)"></b-add-vacation>
		</v-dialog>

		<v-delete-dialog
			v-model="deleteDialog"
			:module="'attendance/deleteVacation'"
			:parameters="deleteItem"
			@on-delete="fetch(search)">
			{{ $T('PermissionEmployeeAttendance.delete-message-permission') }}
		</v-delete-dialog>
	</div>
</template>

<script>
import attendance from './attendance';
import BAddVacation from '@/components/forms/BAddVacation.vue';
import moment, { DATE_FORMAT } from '@/utils/moment';
import { employeesTypes } from '@/utils/enum';
import { mapState } from 'vuex';

export default {
	name: 'VacationAttendance',

	mixins: [attendance],

	props: {
		search: { type: Object },
		employee: { type: Object },
		employeeId: { type: String },
		loadingFetchEmployee: { type: Boolean },
	},

	components: { BAddVacation },

	data() {
		return {
			headers: [
				{
					text: this.$T('table.type'),
					value: 'leaveType',
					name: 'type',
					setValueExpr: (value, index) => value.name,
				},
				{
					text: this.$T('table.startDate'),
					value: 'startTime',
					name: 'startDate',
					cellClass: 'ltr',
				},
				{
					text: this.$T('table.endDate'),
					value: 'endDate',
					name: 'endDate',
					cellClass: 'ltr',
				},
				{ text: this.$T('table.cause'), value: 'reason', name: 'cause' },
				{
					text: this.$T('table.requestDate'),
					value: 'date',
					type: 'date',
					dateFormat: DATE_FORMAT,
					name: 'requestDate',
				},
				{ text: '', value: 'actions', name: 'actions', width: 40 },
			],

			storeModel: 'attendance/fetchPermissionsById',
			employeesTypes,
			type: null,
			excelLoading: false
		};
	},

	computed: {
		...mapState({
			permissions: state => state.leaveOrPermission.permissions
		})
	},

	methods: {
		moment,
		searchByType() {
			this.$store.dispatch('attendance/fetchPermissionsById', { 
				leaveTypeId: this.type, 
				employeeId: this.$route.query.employeeId,
				id: this.$route.query.employeeId,
				DateFrom: this.search.DateFrom,
				DateTo: this.search.DateTo,
			}).then((data) => {
				// 	res.data.filter(c => this.vacationTypeId ? c.leaveType.id === this.vacationTypeId : true)
				this.$refs.table.resetShownRows()
				this.items.push(...data);
				this.$refs.table.addScrollItems(data);
			}).finally(() => {
				this.loading = false;
			});
		},

		exportFile() {
			this.excelLoading = true
			this.$store.dispatch('reports/fetchExcelPermissionEmp', {
				dateFrom : this.search.DateFrom,
				dateTo: this.search.DateTo,
				employeeId:this.$route.query.employeeId
			}).finally(() => {
				this.excelLoading = false
			})
		}
	},

	mounted() {
		this.fetch(this.search);
	},
};
</script>

<style lang="scss" scoped></style>
